/**
 *
 * Asynchronously loads the component for EventPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
